import { ResizeMouseEventHandler, State } from './types';
import { consumeDeltaAdd, consumeDeltaSubtract, setStyles } from './utils';

export const reduceIsCollapsed = (
  state: State,
  configIndex: number,
  isCollapsed: boolean,
  skipReducing = false,
  onResizeEnd?: ResizeMouseEventHandler
): State => {
  if (skipReducing) {
    return setStyles(state);
  }
  const config = state.configs[configIndex];
  if (!config) return state;
  const delta = config.currentValue - config.collapsedValue;
  const consumeDelta = isCollapsed ? consumeDeltaAdd : consumeDeltaSubtract;
  const [newStateLeft, consumedDeltaLeft] = consumeDelta(
    delta,
    configIndex + 1,
    state
  );
  if (Math.round(consumedDeltaLeft) === Math.round(delta)) {
    return setStyles({
      ...newStateLeft,
      isResizeEndScheduled: Boolean(onResizeEnd),
      configs: newStateLeft.configs.map((config, index) =>
        index === configIndex ? { ...config, isCollapsed } : config
      ),
    });
  }

  const [newStateRight] = consumeDelta(
    consumedDeltaLeft - delta,
    configIndex - 1,
    newStateLeft
  );

  return setStyles({
    ...newStateRight,
    isResizeEndScheduled: Boolean(onResizeEnd),
    configs: newStateRight.configs.map((config, index) =>
      index === configIndex ? { ...config, isCollapsed } : config
    ),
  });
};
